import { SupabaseDownloadSignatureRequestCertificateRepository } from '@/shared/infra/repositories'
import type { DownloadSignatureRequestCertificate } from '@/shared/domain'
import { makeSupabaseEdgeHttpClient } from '@/main/factories/http'

export function makeDownloadSignatureRequestCertificate(): DownloadSignatureRequestCertificate {
  return new SupabaseDownloadSignatureRequestCertificateRepository(
    makeSupabaseEdgeHttpClient(),
  ).execute
}
